
import { GET_META_DATA } from '@/api/apolloCommonQueries';

export default {
  name: 'authLayout',
  data() {
    return {
      loadingPopup: false,
      pageScroll: true,
      redirect: null,
    };
  },
  head() {
    return {
      title: this.headData?.title || '1StopBedrooms',
      meta: [
        {
          name: 'robots',
          content: this.headData?.robots || 'index, follow',
        },
        {
          hid: 'description',
          name: 'description',
          content: this.headData?.description ? this.headData.description
            : '1Stop Bedrooms is your one stop shop for bedroom furniture. Shop the largest collection of bedroom sets. 5 star rated. Free delivery. Financing available.',
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.ogData?.title || '1StopBedrooms',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: this.ogData?.url || 'https://www.1stopbedrooms.com/',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.ogData?.description ? this.headData.description
            : '1Stop Bedrooms is your one stop shop for bedroom furniture. Shop the largest collection of bedroom sets. 5 star rated. Free delivery. Financing available.',
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.ogData?.image || 'https://www.1stopbedrooms.com/media/1stopbedrooms-logo.jpg',
        },
        {
          hid: 'og:image:alt',
          property: 'og:image:alt',
          content: this.ogData?.image_alt || '1StopBedrooms',
        },
      ],
    };
  },
  watch: {
    '$route.path': function watchRoute() {
      this.$nextTick(() => {
        this.getMetadata();
        this.$nuxt.$emit('change-global-loading', false);
      });
    },
  },
  async fetch() {
    await this.getMetadata();
  },
  computed: {
    headData() {
      return this.$store.state.metaData?.addons?.head;
    },
    ogData() {
      return this.$store.state.metaData?.addons?.metaOg;
    },
  },
  created() {
    this.$store.commit('setMessages', []);
  },
  beforeDestroy() {
    this.$store.commit('setMessages', []);
  },
  methods: {
    async getMetadata() {
      this.redirect = null;
      const parameters = Object.entries(this.$route.query)
        .map(([name, value]) => ({ name, value: (value || '').split('$,$') }));
      const result = await this.$graphql.default.request(GET_META_DATA, {
        slug: this.$route.path[0] === '/' ? this.$route.path.slice(1) : this.$route.path,
        parameters: parameters.length ? parameters : null,
      });
      const redirect = result.pageMetadata?.addons?.redirect?.url;
      if (redirect) {
        this.redirect = redirect[0] === '/' ? redirect : `/${redirect}`;
        window.location.href = this.redirect;
        return;
      }
      this.$store.commit('setMetaData', result.pageMetadata || {});
    },
  },
};
